export default __webpack_public_path__ + "static/media/atore_4.8894e220.png";